import { fireStore } from '../firebase';
import isEmpty from 'lodash/isEmpty';

export const getDocs = async ({ lastDoc, limit, filter }) => {
  let docRef = fireStore.collection('quotas');

  if (!isEmpty(filter.created_by)) {
    if (Array.isArray(filter.created_by)) {
      docRef = docRef.where('created_by', 'in', filter.created_by);
    } else {
      docRef = docRef.where('created_by', '==', filter.created_by);
    }
  }

  if (filter.type) {
    docRef = docRef.where('type', '==', filter.type);
  }

  if (filter.sow) {
    docRef = docRef.where('sow', '==', filter.sow);
  }

  if(!isEmpty(filter.data_freq)) {
    docRef = docRef.where('data_freq', '==', filter.data_freq);
  }

  if (filter.created_at && filter.created_at.length === 2) {
    docRef = docRef.where('created_at', '>=', filter.created_at[0].startOf('day').unix()).where('created_at', '<=', filter.created_at[1].endOf('day').unix());
  }

  if (filter.price) {
    docRef = docRef.where('price', '==', filter.price * 1);
  }

  if (filter.project) {
    docRef = docRef.where('project', '==', filter.project);
  }

  if (!isEmpty(filter.level)) {
    docRef = docRef.where('level', '==', filter.level);
  }

  docRef = docRef.orderBy('created_at', 'desc').orderBy('index', 'asc').limit(limit);

  if (lastDoc) {
    docRef = docRef.startAfter(lastDoc);
  }

  return await docRef.get()
  .then((documentSnapshots) => {
    return documentSnapshots.docs;
  })
  .catch(error => { console.log(error); return error })
}

export const addDoc = async ({data}) => {
  // let docRef = fireStore.collection('quotas').where('project', '==', data.project).limit(1);
  // return await docRef.get()
  // .then((docSnapshot) => {
  //     if (docSnapshot.docs.length) {
  //       return { isExist: true };
  //     } else {
  //       fireStore.collection('quotas').add(data)
  //       return { isExist: false };
  //     }
  // });
  return await fireStore.collection('quotas').add(data);
}
